import { all, fork, takeEvery } from "redux-saga/effects";
import { protoHandler } from "../../libs/proto";
import { CLIENT_RESOLVE_USERNAME, USER_INFO } from "../../constants/methods";
import { addUser } from "./actions";
import { GET_USER, GetUserActionType, GOTO_USER, GoToUserActionType } from "./types";
import { ClientResolveUsernameResponse } from "../../proto/ClientResolveUsername_pb";
import { Room } from "../../proto/Global_pb";
import { goToRoomByRoomName, goToUserByUsername } from "../../libs/services";
import store from "../index";
import { EVENT_NEW_SNACKBAR } from "../../constants/events";
import i18next from "i18next";

function* onGetUser() {
  yield takeEvery<GetUserActionType>(GET_USER, function* (action) {
    new Promise(async (resolve, reject) => {
      try {
        const user = await protoHandler(USER_INFO, { userId: action.payload.userId });
        if (user.user) await store.dispatch(addUser(user.user));
        resolve("");
      } catch (e) {
        reject();
      }
    }).then();
  });
}

function* onGoToUser() {
  yield takeEvery<GoToUserActionType>(GOTO_USER, function* (action) {
    new Promise(async (resolve, reject) => {
      try {
        let username = await action.payload.userId;
        if (username.includes("@")) username = await username.replace("@", "");
        const { user, room, type }: ClientResolveUsernameResponse.AsObject = await protoHandler(CLIENT_RESOLVE_USERNAME, { username: username });
        type === Room.Type.CHAT ? await goToUserByUsername(user) : await goToRoomByRoomName(room);
        resolve("");
      } catch (e: any) {
        document.dispatchEvent(
          new CustomEvent(EVENT_NEW_SNACKBAR, {
            detail: {
              message: i18next.t("global.search_not_found"),
              options: { variant: "warning", autoHideDuration: 3000 },
            },
          })
        );
        reject();
      }
    }).then();
  });
}

export function* usersSaga() {
  yield all([fork(onGetUser), fork(onGoToUser)]);
}
